export const MAX_QUICK_REPLY_BUTTONS = 7;